import styled from 'styled-components';

export const StyledErrorBoundaryComponent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
`;

export const ButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xxl};
`;
